import React from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

// redux
import { useAppDispatch } from 'redux/store';
import { useSelector } from 'react-redux';
import { getCurrentLecture } from 'redux/selectors/lecture-page';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { LeftPanelView } from 'redux/schemas/app/lecture-page';

// components
import { hideAddUI } from 'lecture_pages/templates/components/nv-add-component';
import { setBottomBarVisibility, setLeftPanelView } from 'redux/actions/lecture-pages';
import TopPanelActionButton from './top-panel-action-button';

import { config } from '@config/config.json';

const NovoAiStartButton = () => {
  const dispatch = useAppDispatch();

  const currentLecture = useSelector(getCurrentLecture);
  const currentInstitution = useSelector(getCurrentInstitution);
  const leftPanelView = useSelector(state => state.app.lecturePage.leftPanelView);

  const isLinkedLesson = !currentLecture?.isLinked;

  const styles = css`
    .novo-ai-btn {
      ${leftPanelView === LeftPanelView.NOVO_AI && (`
        background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
      `)}
    }
  `;

  const openLHSNovoAi = () => {
    if (leftPanelView === LeftPanelView.NOVO_AI) {
      hideAddUI(dispatch);
    } else {
      dispatch(setBottomBarVisibility(false));
      dispatch(setLeftPanelView(LeftPanelView.NOVO_AI));
    }
  };

  return (
    <div className='ml-4' css={styles}>
      {currentInstitution.hasAiComponentGeneration && (
        <TopPanelActionButton
          icon='gen-ai'
          tooltipText={isLinkedLesson
            ? t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.NOVO_AI()
            : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.NOVO_AI_DISABLED_TEXT()}
          disabled={!isLinkedLesson}
          onClick={openLHSNovoAi}
          className='novo-ai-btn'
          ariaLabel={isLinkedLesson
            ? t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.NOVO_AI()
            : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.NOVO_AI_DISABLED_TEXT()}
          dataQa={config.pendo.lectureEdit.editMenuTopPanel.openNovoAiOption}
        />
      )}
    </div>
  );
};

export default NovoAiStartButton;
